import { MessagesSquare, PenLine, Package, BookOpen, LineChart, ListChecks } from "lucide-react";

export const GUIDE_MODES = [
  {
    key: "ask",
    label: "Ask the AI Business Guide",
    icon: MessagesSquare,
    blurb: "An open space for any question across content, products, business and planning.",
    starters: [
      "Help me think through what my audience needs most right now.",
      "What content gaps do you notice across my themes?",
      "I'm feeling scattered. Help me focus my next two weeks.",
    ],
  },
  {
    key: "content_studio",
    label: "Content Studio",
    icon: PenLine,
    blurb: "Draft, improve and repurpose blogs, social posts, email, scripts and web copy in your voice.",
    starters: [
      "Draft an Instagram caption on the theme of Productivity.",
      "Turn my latest blog into a 5-email nurture sequence.",
      "Give me 5 fresh, non-repetitive hooks for a post on Growth.",
    ],
  },
  {
    key: "product_builder",
    label: "Product Builder",
    icon: Package,
    blurb: "Design guides, templates, workbooks, courses and bundles, with pricing and launch strategy.",
    starters: [
      "Recommend a digital product my audience needs.",
      "Outline a practical 7-day email challenge for my audience.",
      "Help me price and position a template pack.",
    ],
  },
  {
    key: "book_builder",
    label: "Book Builder",
    icon: BookOpen,
    blurb: "Brainstorm, outline, expand and edit books, from chapters to back-cover copy.",
    starters: [
      "Help me outline a book based on my best content.",
      "Expand my notes on this topic into a chapter structure.",
      "Suggest three strong book titles for my niche.",
    ],
  },
  {
    key: "business",
    label: "Business Insights",
    icon: LineChart,
    blurb: "Strategic, grounded advice on growth, marketing, revenue, partnerships and workflow.",
    starters: [
      "What's a simple, sustainable way to grow my email list?",
      "Suggest an evergreen offer that fits my business.",
      "Help me map a launch plan for a new offer.",
    ],
  },
  {
    key: "planner",
    label: "Project Planner",
    icon: ListChecks,
    blurb: "Plan projects, roadmaps, content pipelines and launch checklists with clear priorities.",
    starters: [
      "Build me a 4-week content plan around the theme of Marketing.",
      "Create a publishing checklist for a new blog post.",
      "Help me prioritize my projects for this month.",
    ],
  },
];

export const modeToProjectType = {
  ask: "draft",
  content_studio: "content",
  product_builder: "product",
  book_builder: "book",
  business: "plan",
  planner: "plan",
};

export const getMode = (key) => GUIDE_MODES.find((m) => m.key === key) || GUIDE_MODES[0];
